import React, { useEffect, useState } from "react";
import {
  Tooltip,
  IconButton,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import BlockIcon from "@material-ui/icons/Block";
import { Alert } from "@material-ui/lab";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import useModal from "src/hooks/useModal";
import { StyledButton } from "src/components/CustomButtons/TgButton";
import useStyles from "src/views/viewAdministrador/areasComunales/useStyle";
import * as FirestoreService from "src/views/viewAdministrador/metodosDePago/cuentasBancarias/services/firestore";

const DeleteBank = ({ cuenta, Transition }) => {
  const conjunto = useSelector((state) => state.complex.complex);
  const { enqueueSnackbar } = useSnackbar();
  const [open, handleOpen, handleClose] = useModal();
  const [elm, setElm] = useState(null);
  const [detalleIngresos, setDetalleIngresos] = useState({});
  const [detalleEgresos, setDetalleEgresos] = useState({});
  const [canDelete, setCanDelete] = useState(true);
  const classes = useStyles();

  useEffect(() => {
    let unsubIng = () => {};
    let unsubEgr = () => {};
    try {
      unsubIng = FirestoreService.getIngresos(
        {
          next: (querySnapshot) => {
            const ingresos = [];
            querySnapshot.docs.forEach((item) => {
              const ingresoData = item.data();
              ingresoData.id = item.id;
              ingresoData.Tipo = "Ingresos";
              ingresos.push(ingresoData);
            });
            setDetalleIngresos(ingresos);
          },
        },
        conjunto.id,
        elm
      );
      unsubEgr = FirestoreService.getEgresos(
        {
          next: (querySnapshot) => {
            const egresos = [];
            querySnapshot.docs.forEach((item) => {
              const egresosData = item.data();
              egresosData.id = item.id;
              egresosData.Tipo = "Egresos";
              egresos.push(egresosData);
            });
            setDetalleEgresos(egresos);
          },
        },
        conjunto.id,
        elm
      );
    } catch (e) {
      enqueueSnackbar("No se pudo obtener el saldo", { variant: "error" });
    }
    return () => {
      unsubIng();
      unsubEgr();
    };
  }, [elm]);

  const confir = async () => {
    const cobros = [];
    let isSaldoI = false;
    let ingreso = null;

    detalleIngresos.forEach((item) => {
      cobros.push(item?.Cobros);
      if (item?.Forma === "Saldo inicial") {
        isSaldoI = true;
        ingreso = item;
      }
    });
    if (detalleIngresos.length === 0) {
      isSaldoI = true;
    }
    if (detalleEgresos?.length > 0 || detalleIngresos?.length > 1) {
      setCanDelete(false);
    } else if (
      detalleIngresos?.length === 1 &&
      detalleIngresos[0]?.Forma !== "Saldo inicial"
    ) {
      setCanDelete(false);
    } else if (
      detalleEgresos?.length === 0 &&
      detalleIngresos?.length >= 0 &&
      detalleIngresos?.length <= 1 &&
      isSaldoI
    ) {
      setCanDelete(true);
      if (detalleIngresos?.length > 0) {
        await FirestoreService.anularSaldoI(conjunto.id, ingreso);
      }
      if (elm) {
        FirestoreService.deleteCuentabyID(conjunto.id, elm)
          .then(() => {
            enqueueSnackbar("¡Cuenta eliminada con éxito!", {
              variant: "info",
            });
          })
          .catch(() => {
            enqueueSnackbar("¡Error al eliminar la cuenta!", {
              variant: "error",
            });
          })
          .finally(() => {
            setElm(null);
          });
      }
      handleClose();
    }
  };

  function deleteCuenta(event) {
    handleOpen();
    setElm(event);
  }

  const handleDialogClose = () => {
    setCanDelete(true);
    handleClose();
  };

  return (
    <>
      <Tooltip title="Eliminar">
        <IconButton
          aria-label="eliminar"
          onClick={() => deleteCuenta(cuenta.id)}
        >
          <DeleteForeverIcon />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleDialogClose}
        aria-labelledby="draggable-dialog-title"
        TransitionComponent={Transition}
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          <h5>
            {" "}
            <DeleteForeverIcon /> Eliminar{" "}
          </h5>
        </DialogTitle>
        <DialogContent>
          <Alert severity="error">
            <DialogContentText>
              ¿Estás seguro que quieres eliminar el banco?
            </DialogContentText>
            {canDelete ? null : (
              <DialogContentText>
                No es posible eliminar un banco que aún contiene transacciones.
                Contacte con el administrador.
              </DialogContentText>
            )}
          </Alert>
        </DialogContent>
        <Divider />
        <DialogActions>
          <StyledButton
            variant="outlined"
            autoFocus
            onClick={handleClose}
            color="primary"
            startIcon={
              <BlockIcon fontSize="small" className={classes.iconRed} />
            }
          >
            Cancelar
          </StyledButton>
          <StyledButton
            variant="contained"
            onClick={() => {
              confir();
            }}
            disabled={!canDelete}
            color="primary"
          >
            <DeleteForeverIcon className="me-2" />
            Eliminar
          </StyledButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteBank;
